var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStarfill({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 -70.4590 101.5700 70.4590",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.2676 2.29492C26.0742 3.66211 28.2715 3.125 30.9082 1.2207L50.7812-13.3789L70.7031 1.2207C73.291 3.125 75.4883 3.66211 77.2949 2.29492C79.0527 0.976562 79.3945-1.26953 78.3203-4.29688L70.459-27.6855L90.5273-42.0898C93.1641-43.8965 94.2871-45.8984 93.5547-48.0469C92.8711-50.0977 90.8203-51.0742 87.5977-51.0742L62.9883-51.0742L55.5176-74.4141C54.541-77.4902 53.0273-79.1016 50.7812-79.1016C48.584-79.1016 47.0703-77.4902 46.0449-74.4141L38.5742-51.0742L13.9648-51.0742C10.7422-51.0742 8.74023-50.0977 8.00781-48.0469C7.32422-45.8984 8.44727-43.8965 11.0352-42.0898L31.1035-27.6855L23.2422-4.29688C22.168-1.26953 22.5098 0.976562 24.2676 2.29492Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStarfill);
export default __webpack_public_path__ + "static/media/star.fill.0dd86b8f791767f003233e8373bc84e0.svg";
export { ForwardRef as ReactComponent };